module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AD - Andorra.6cf4b49c.svg";